import { z } from 'zod';

export const supplierSchema = z.object({
  name: z.string().min(1, 'Supplier name is required').max(100, 'Name too long'),
  contactPerson: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().email('Invalid email format').optional().or(z.literal('')),
  address: z.string().optional(),
  taxId: z.string().optional(),
  status: z.enum(['active', 'inactive']),
});

export type SupplierFormData = z.infer<typeof supplierSchema>;
